/** @jsx h */
/** @jsxFrag Fragment */
import { h } from "preact";
import { useState } from "preact/hooks";

import { cx } from "@utils/utils";
import { HsvaColor, hsvaToHslaString } from "@utils/color";
import { ColorPicker } from "@uiw/utils";
import { DatUIBaseProps } from "./dat.tsx";

export interface DatColorProps extends DatUIBaseProps {
  value: HsvaColor;
  onChange: (c: Partial<HsvaColor>) => void;
}
export function DatColor(props: DatColorProps) {
  const [showPicker, setShowPicker] = useState(false);
  const { label, style } = props;

  const labelWidth = "40%";
  const labelText = props.label || "DefaultLabel";

  const picker = showPicker && <ColorPicker hsva={props.value} onChange={props.onChange} />;
  return (
    <li
      className={cx("cr", "color", props.class)}
      style={{ borderLeftColor: `${hsvaToHslaString(props.value)}`, ...style }}
    >
      <label>
        <span className="label-text" style={{ width: labelWidth }}>
          {labelText}
        </span>
        <div
          style={{
            backgroundColor: hsvaToHslaString(props.value),
            width: `calc(100% - ${labelWidth})`,
          }}
        >
          <div
            className="swatch"
            onClick={() => setShowPicker(!showPicker)}
            role="button"
            tabIndex={0}
          >
            {hsvaToHslaString(props.value)}
          </div>
          {picker}
        </div>
      </label>
    </li>
  );
}
